export const storageKeys = {
  token: '@neuron-os/token',
  companyId: '@neuron-os/company-id',
  companyName: '@neuron-os/company-name',
  currencyData: '@neuron-os/currency-data',
};
